import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
import {
  CreateModuleMutation,
  CreateModuleMutationVariables,
  useCreateModuleMutation,
} from "@src/features/libraryItem/module/hooks/useNewModule.generated";
import { CONTENT_LIBRARY_REFETCH_QUERIES } from "@src/lib/contexts/TagContext/TagContext";
import { route } from "nextjs-routes";

export const useNewModule = (
  onComplete?: () => void,
): ((
  options?: Apollo.MutationHookOptions<
    CreateModuleMutation,
    CreateModuleMutationVariables
  >,
) => void) => {
  const [createModule] = useCreateModuleMutation({
    variables: {
      input: {
        name: "",
      },
    },
    refetchQueries: CONTENT_LIBRARY_REFETCH_QUERIES,
    onCompleted(data) {
      onComplete ? onComplete() : null;
      if (data?.createModule?.module?.id) {
        window.open(
          route({
            pathname: "/library/library-item/[id]",
            query: { id: data.createModule.module.libraryItem.id },
          }),
          "_blank",
        );
      }
    },
  });
  return createModule;
};

gql`
  mutation createModule($input: ModuleInput!) {
    createModule(input: $input) {
      success
      module {
        ...Module
      }
    }
  }
`;
